module.exports = __webpack_public_path__ + "img/pexels-photo-1647905.48d71fc5.jpg";